import { useState } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Accordion from '@zenbusiness/zui/Accordion';
import AccordionDetails from '@zenbusiness/zui/AccordionDetails';
import AccordionSummary from '@zenbusiness/zui/AccordionSummary';
import Chip from '@zenbusiness/zui/Chip';
import Divider from '@zenbusiness/zui/Divider';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import { InvoiceCardRoot } from './InvoiceCard.style';

export default function InvoiceCard({
  isSuccess, amount, items = []
}) {
  const [expanded, setExpanded] = useState(false);

  const chipColor = isSuccess ? 'success' : 'error';
  const labelId = isSuccess
    ? 'dashboard.paymentReturn.invoiceCard.paid'
    : 'dashboard.paymentReturn.invoiceCard.unpaid';

  const hasItems = items && items.length > 0;

  return (
    <InvoiceCardRoot>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ p: 3 }}
      >
        <Chip color={chipColor} size="small">
          <FormattedMessage id={labelId} />
        </Chip>
        <Text size="2xl" weight="bold">
          {amount}
        </Text>
      </Stack>
      <Divider />
      <Accordion
        expanded={expanded}
        onChange={() => setExpanded((prev) => !prev)}
        disableGutters
        elevation={0}
        sx={{ '&:before': { display: 'none' } }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ width: 24, height: 24 }} />}>
          <Text size="sm" weight="bold">
            <FormattedMessage id="dashboard.paymentReturn.invoiceCard.details" />
          </Text>
        </AccordionSummary>
        <AccordionDetails>
          <Stack gap={1}>
            {hasItems ? items.map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Stack key={`${index}-${item.description}`} direction="row" justifyContent="space-between">
                <Text size="sm" color="secondary">{item.description}</Text>
                <Text size="sm" weight="bold">{item.amount}</Text>
              </Stack>
            )) : (
              <Stack direction="row" justifyContent="space-between">
                <Text size="sm" color="secondary">
                  <FormattedMessage id="dashboard.paymentReturn.invoiceCard.total" />
                </Text>
                <Text size="sm" weight="bold">{amount}</Text>
              </Stack>
            )}
          </Stack>
        </AccordionDetails>
      </Accordion>
    </InvoiceCardRoot>
  );
}

InvoiceCard.propTypes = {
  isSuccess: PropTypes.bool.isRequired,
  amount: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string.isRequired,
    amount: PropTypes.string.isRequired
  }))
};
